import React from "react";
import FacultyProfilePage from "../components/FacultyProfile";
import Navbar from "../components/Navbar";

const KamayaniSharma = () => {
    return (
        <>
            <Navbar />
            <FacultyProfilePage
                name="Kamayani Sharma"
                image="/Faculty-seasons-Cover.jpg"
                profileImage="/Kamayani-Sharma-bio.jpg"
                bio="Kamayani Sharma is an independent writer, researcher, translator and podcaster. She graduated in philosophy from the University of Pune and holds an MA from the School of Arts & Aesthetics, JNU. A former text editor with ART India, she continues to serve as New Delhi correspondent for the magazine. Her critical writing has appeared in publications worldwide as well as peer-reviewed journals and edited volumes. In 2020, she was a finalist for the International Award for Art Criticism and in 2022, she received the Kalpalata Fellowship in Visual Culture Writing from the Kamala and Ganesh Sitapati Trust. Sharma runs ARTalaap, South Asia’s first independent visual culture podcast."
            />
        </>
    );
};

export default KamayaniSharma;